"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncChannel = syncChannel;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _marked = /*#__PURE__*/_regenerator["default"].mark(syncChannel);

function syncChannel(channel, options) {
  var successActionCreator, failureActionCreator, transform, data, transformedData;
  return _regenerator["default"].wrap(function syncChannel$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          successActionCreator = options.successActionCreator, failureActionCreator = options.failureActionCreator, transform = options.transform;
          _context.prev = 1;

        case 2:
          if (!true) {
            _context.next = 11;
            break;
          }

          _context.next = 5;
          return (0, _effects.take)(channel);

        case 5:
          data = _context.sent;
          transformedData = transform ? transform(data) : data;
          _context.next = 9;
          return (0, _effects.put)(successActionCreator(transformedData));

        case 9:
          _context.next = 2;
          break;

        case 11:
          _context.next = 21;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);

          if (!failureActionCreator) {
            _context.next = 20;
            break;
          }

          _context.next = 18;
          return (0, _effects.put)(failureActionCreator(_context.t0));

        case 18:
          _context.next = 21;
          break;

        case 20:
          console.error('The following error has been ignored because no `failureActionCreator` has been set:', _context.t0);

        case 21:
          _context.prev = 21;
          _context.next = 24;
          return (0, _effects.cancelled)();

        case 24:
          if (!_context.sent) {
            _context.next = 26;
            break;
          }

          channel.close();

        case 26:
          return _context.finish(21);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 13, 21, 27]]);
}